import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AngularResizeElementDirection, AngularResizeElementEvent } from '../../../../directives/resize-element';
import { Subscription } from 'rxjs';
import { FilterService } from 'src/app/services/filter.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { EnhancementService } from 'src/app/services/enhancements-service';
import { NavigationService } from 'src/app/services/navigation.service';
import { CommentsNotesService } from '../comments-notes.service';
import moment from 'moment';
import _ from 'lodash';
import { MatDialog } from '@angular/material/dialog';
import { DialogService } from 'src/app/services/dialog.service';
import { PopupDeleteComponent } from '../../popup-delete/popup-delete.component';
import { HashtagService } from '../hashtag.service';

@Component({
    selector: 'app-individual-notes',
    templateUrl: './individual-notes.component.html',
    styleUrls: ['./individual-notes.component.scss'],
    standalone: false
})
export class IndividualNotesComponent implements OnChanges {

  @Input("offcanvasRightIndividualView") offcanvasRightIndividualView:any;
  @Input("individualSelectedData") individualSelectedData:any;
  
  @Output("onResizeSideWindow") onResizeSideWindow = new EventEmitter<any>();
  
  public readonly AngularResizeElementDirection = AngularResizeElementDirection;
  public data: any = {};
  public onResizeSide(evt: AngularResizeElementEvent): void {
    this.data.width = evt.currentWidthValue;
    this.data.height = evt.currentHeightValue;
    this.data.top = evt.currentTopValue;
    this.data.left = evt.currentLeftValue;
    this.onResizeSideWindow.emit(this.data);
  }

  reqSubcription: Subscription[] = [];
  selectedIndividualValue:any;
  employee_key:any;
  decryptedParams:any;
  clientKey:any;
  moduleKey:any;
  dashboardKey:any;
  
  headingIcons = [{"icon": "notes_sorting", "tooltip": "Sort"}, {"icon": "notes_search", "tooltip": "Search"}, {"icon": "expand_circle", "tooltip": "Fullscreen Toggle"}];
  messages:any = [];
  noteValue:any;
  currentPatient:any;
  loadComments = false;
  editEnabled = false;
  editedEvent:any;
  error:any= "";
  hashTagArray:any = [];
  hashTagData:any = [];
  enteredText:any;
  sort:any = 'asc';
  isSending = false;

  orderBy(order:any) {
    this.sort = order;
    this.messages = _.orderBy(this.messages, ['insert_timestamp'], [order]);
  }

  constructor(
    private router: ActivatedRoute,
    private commentsNotesService: CommentsNotesService,
    private navigationService: NavigationService,
    public filterService: FilterService, 
    private dashboardService: DashboardService,
    private enhancementService: EnhancementService,
    private cdr: ChangeDetectorRef,
    private elementRef: ElementRef,
    private dialog: MatDialog,
    private dialogService: DialogService,
    private hashtagService: HashtagService
  ) {
    this.router.params.subscribe((p: any) => {

      // Query Params
      this.router.queryParams.subscribe((params:any) => {
        this.decryptedParams = this.navigationService.decryptData(params);
        this.clientKey = this.decryptedParams["cl_key"];
        this.moduleKey = this.decryptedParams["md_key"];
        this.dashboardKey = this.decryptedParams["ds_key"];

        let desginObj = this.dashboardService.dashboardDetailsOfNotes;
        if( desginObj && Object.keys(desginObj)?.length>0) {
          if(desginObj?.dashboardKey) {
            this.dashboardKey = desginObj?.dashboardKey;
          }
        }
      })
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['individualSelectedData'].currentValue != changes['individualSelectedData'].previousValue) {
      this.messages = [];
      this.currentPatient = changes['individualSelectedData'].currentValue;
      // debugger
      this.loadComments = false;
      // this.editEnabled = false;
      this.editedEvent = {};
      this.noteValue = '';
      this.isSending = false;
      this.error = "";
      let empkey = sessionStorage.getItem('employee_key');
      if (empkey) {
        const parsedEmpkey: any = JSON.parse(empkey);
        this.employee_key = parsedEmpkey._value;
      }

      this.dashboardKey = this.currentPatient?.dashboardKey ? this.currentPatient.dashboardKey : this.dashboardKey
      this.loadCommentsData(this.currentPatient);
      
      if(this.currentPatient?.config?.isHashtag) {
        this.getHashtagData();
      }
    }    
  }

  getHashtagData() {
    // debugger
    let config = this.currentPatient?.config;
    let src_pat_id = this.currentPatient?.value?.['source_patient_id'] ||
    this.currentPatient?.value?.[config?.payloadKey] ||
    this.currentPatient?.value?.['patient_id'] || 
    this.currentPatient?.value?.['prescriber_nm'] || '';
    let obj:any = {
      "brand_key" : this.filterService.baseQuery?.brand_key,
      "hashtag_type": config.prefix
    }

    this.reqSubcription.push(
      this.hashtagService.getHashTags(obj).subscribe((res:any)=> {
        this.hashTagArray = res ? res : [];
        if(this.hashTagArray.length>0) {
          // let group = config.prefix + " - " + this.currentPatient.key
          let findHash = this.hashTagArray.find((f:any) => (f.hashtag_type+' - '+f.hashtag_key)== config.prefix + ' - '+src_pat_id);
          if(findHash?.hashtag_value) {
            this.hashTagData = findHash?.hashtag_value?.split(',') || [];
          } else {
            this.hashTagData = [];
          }
        } else {
          this.hashTagData = [];
        }
      })
    )
  }

  remove(hash: string): void {
    const index = this.hashTagData.indexOf(hash);
    let config = this.currentPatient?.config;

    if (index >= 0) {
      this.hashTagData.splice(index, 1);
      let src_pat_id = this.currentPatient?.value?.['source_patient_id'] ||
      this.currentPatient?.value?.[config?.payloadKey] ||
      this.currentPatient?.value?.['patient_id'] || 
      this.currentPatient?.value?.['prescriber_nm'] || '';
      let fndHashTag = this.hashTagArray.find((f:any)=> f.hashtag_key == src_pat_id && f.hashtag_type == config.prefix);
      let updateKey = fndHashTag?.hash_tag_dtls_key || null;

      this.updateTheHashTags(this.hashTagData.toString(), updateKey)
    }
  }

  loadCommentsData(data:any) {

    let postdata: any = { 
      "report_typ": "G", // G - Generic
      "dashboard_key": this.dashboardKey,
      "module_key": this.moduleKey,
      "from_date": "2000-01-01", // moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'),
      "to_date": moment().format('YYYY-MM-DD'),
      "brand_key" : this.filterService?.baseQuery?.brand_key
    };

    this.reqSubcription.push(
      this.commentsNotesService.notesQuery(postdata).subscribe((res:any)=> {
        let messages = this.commentsNotesService.filterByKey(res, data);
        this.messages = _.orderBy(messages, ['insert_timestamp'], [this.sort]);
        this.loadComments = true;
        this.myFunction();
        this.error = "";
      }, err=> {
        this.error = "There is an issue...";
        this.loadComments = false;
        this.messages = [];
      })
    )
  }

  // Handling Insert
  sendMessage($event: KeyboardEvent | any): void {
    $event.preventDefault();

    // Ignore repeat submits while an insert is still in flight, otherwise every
    // Enter / send click posts the same note again and creates duplicates.
    if(!this.noteValue || this.isSending) return;

    const noteText = this.noteValue;
    this.isSending = true;
    this.noteValue = '';

    if(this.currentPatient?.config?.isHashtag) {
      let hashTagMatches = noteText.match(/(?:^|\s)(#[\w_]+)/g);
      
      if(hashTagMatches)
        if(hashTagMatches || hashTagMatches?.length) {
        let hashtags = hashTagMatches.map((tag:any) => tag.trim());
        if(hashtags?.length) {
          this.updateTheHashTags(hashtags);
          setTimeout(() => {
            this.hashTagData = [...new Set([...this.hashTagData, ...hashtags])];
          }, 500);
        }
      }
    }

    let postdata: any = { 
      "report_typ": "I",
      "module_key": this.dashboardService.moduleKey,
      "dashboard_key": this.dashboardKey,
      "comments": noteText,
      "brand_key" : this.filterService?.baseQuery?.brand_key,
    };
    
    let config = this.currentPatient?.config;
    if(config && config?.conversationKey) {
      let data = this.currentPatient.value;
      postdata["conversation_key"] = [config.prefix, data[config.conversationKey], config.suffix].filter(Boolean).join(' - ');
      postdata[config.payloadKeyName] = data[config.payloadKey];
      postdata[config.payloadKeyName1] = data[config.payloadKey1];

    } else {
      postdata["conversation_key"] =  config.prefix ? config.prefix : 'Patient ID' + ' - ' + this.currentPatient.key,
      postdata["patient_key"] = this.currentPatient.key
    }

    this.reqSubcription.push(this.commentsNotesService.notesQuery(postdata).subscribe((res: any) => {
      this.isSending = false;

      if(res != null && res.length>0) {
        let length = res.length-1;
        let obj = res[length]
        this.messages.push(obj);
      } else {
        // Nothing was inserted - hand the note back to the user.
        this.noteValue = noteText;
      }
      this.myFunction();

    }, (err:any) => {
      this.isSending = false;
      this.noteValue = noteText;
      this.dialogService.customSnackBar('error', 'red', 'Error Message');
    }));
  }
  
  updateTheHashTags(hashTag:any, updateKey?:any) {
    
    let config = this.currentPatient?.config;
    
    // const allHashtags = this.messages.filter((msg: any) => msg.comments).flatMap((msg: any) => {
    //   const matches = msg.comments.match(/#[\w_]+/g);
    //   return matches || [];
    // });

    // let uniqueHashtags:any = [...new Set(allHashtags)];
    
    // if(!uniqueHashtags && uniqueHashtags?.length==0) return;
    
    let src_pat_id = this.currentPatient?.value?.['source_patient_id'] || 
      this.currentPatient?.value?.[config?.payloadKey] ||
      this.currentPatient?.value?.['patient_id'] || 
      this.currentPatient?.value?.['prescriber_nm'] || '';

    let postdata: any = { 
      "module_key": this.dashboardService.moduleKey,
      "dashboard_key": this.dashboardKey,
      "brand_key" : this.filterService?.baseQuery?.brand_key,
      "hashtag_value": hashTag.toString(),
      "hashtag_type": config.prefix,
      "hashtag_key": src_pat_id,
      "hash_tag_dtls_key": updateKey ? updateKey : null
    };

    // if(!this.hashTagArray || this.hashTagArray?.length==0) {
    //   postdata["hash_tag_dtls_key"] = null;
    // } else {
      // let fndHashTag = this.hashTagArray.find((f:any)=> f.hashtag_key == this.currentPatient.key && f.hashtag_type == config.prefix);
      // postdata['hash_tag_dtls_key'] = fndHashTag?.hash_tag_dtls_key || null;
    // }

    this.hashtagService.updateHashTags(postdata).subscribe((res:any)=> {
      if (res.length > 0) {
        const updatedItem = res[0];
        const index = this.hashTagArray.findIndex((f: any) => f.hash_tag_dtls_key === updatedItem.hash_tag_dtls_key);
      
        if (index !== -1) {
          this.hashTagArray[index] = updatedItem;
        } else {
          this.hashTagArray.push(updatedItem);
        }
      }
      
      if (res.length === 0 && updateKey) {
        const index = this.hashTagArray.findIndex((f: any) => f.hash_tag_dtls_key === updateKey);
      
        if (index !== -1) {
          this.hashTagArray.splice(index, 1);
        }
      }
      
      setTimeout(() => {
        this.hashtagService.refreshHashtags.next(true);
      }, 0);
    })
    // debugger
  }

  editIndex:any;
  editedValue:any;

  getMSGHtml(data:any){
    data= data.replaceAll(' ','&nbsp;')
    data=data.replaceAll('\n','<br>')
    return data
  }

  saveEdit(message:any, idx:any) {
    if(!this.editedValue) return;

    if(this.currentPatient?.config?.isHashtag) {
      let hashTagMatches = this.editedValue.match(/(?:^|\s)(#[\w_]+)/g);
      
      if(hashTagMatches)
        if(hashTagMatches || hashTagMatches?.length) {
        let hashtags = hashTagMatches.map((tag:any) => tag.trim());
        if(hashtags?.length) {
          this.updateTheHashTags(hashtags);
          this.hashTagData = [...new Set([...this.hashTagData, ...hashtags])];
        }
      }
    }

    let postdata: any = { 
      "report_typ": "U",
      "module_key": this.dashboardService.moduleKey,
      "dashboard_key": this.dashboardKey,
      "comments": this.editedValue,
      "brand_key" : this.filterService?.baseQuery?.brand_key,
      "user_comments_key" : message.user_comments_key
    };
    this.reqSubcription.push(this.commentsNotesService.notesQuery(postdata).subscribe((res: any) => {
      
      if(postdata["report_typ"] == "U") {
        this.editedValue = '';
        this.editEnabled = false;
        this.messages[idx]['comments'] = postdata.comments;
        this.messages[idx]['update_timestamp'] = moment().format('MM-DD-YYYY');        
      }

    }, (err:any) => {
      this.noteValue = '';
      this.editEnabled = false;
      this.dialogService.customSnackBar('error', 'red', 'Error Message');
    }));
  }

  @ViewChild('editTextArea') editTextArea!: ElementRef;

  editComment($event:any, message:any, idx:any) {
    this.editedValue = message.comments;
    this.editIndex = idx
    this.editEnabled = true;
    this.dialog.closeAll();
    setTimeout(() => {
      this.editTextArea?.nativeElement.focus();
    }, 0);
  }

  deleteComment($event:any, message:any, idx:any) {
    // this.editEnabled = false;
    this.editedEvent = {};
    this.noteValue = '';

    this.dialog.closeAll();
    
    let dialogRef = this.dialog.open(PopupDeleteComponent, {
      maxWidth: '90vw',
      disableClose: true,
      panelClass: "du-custom-modalbox",
      data:'comment'
    });

    dialogRef.afterClosed().subscribe((value) => {
      
      if(value == '1') {
        this.deleteCommentApi(message.user_comments_key, idx)
      }
    }); 
  }

  deleteCommentApi(key:any, idx:any) {

    let postdata: any = { 
      "report_typ": "D",
      "user_comments_key": key
    };
    
    this.reqSubcription.push(this.commentsNotesService.notesQuery(postdata).subscribe((res: any) => {
      this.messages.splice(idx, 1);
    }, (err:any) => {
      this.dialogService.customSnackBar('error', 'red', 'Error Message');
    }));
  }

  myFunction() {
    setTimeout(() => {
      const element: HTMLElement | null = this.elementRef.nativeElement.querySelector('#content')
      if (element) element.scrollIntoView({ block: 'end', behavior: 'smooth' })
    }, 200)
  }

  ngOnDestroy(): void {
    this.reqSubcription.forEach(res => res.unsubscribe())
  }
  
}
